import { ChangeEvent } from "react";
import { Button } from "@/components/ui/button";
import { FileUp } from "lucide-react";
import * as XLSX from "xlsx";

interface GetColumnsFromFileProps {
  onColumnsExtracted: (columns: string[]) => void;
}

export const GetColumnsFromFile = ({
  onColumnsExtracted,
}: GetColumnsFromFileProps) => {
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.name.endsWith(".csv")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target?.result as string;
        const firstLine = text.split("\n")[0];
        const columns = firstLine.split(",").map((col) => col.trim());
        onColumnsExtracted(columns);
      };
      reader.readAsText(file);
    } else if (file.name.endsWith(".xlsx") || file.name.endsWith(".xls")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
        if (jsonData.length > 0) {
          const columns = jsonData[0] as string[];
          onColumnsExtracted(columns);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="file"
        accept=".csv,.xlsx,.xls"
        onChange={handleFileChange}
        className="hidden"
        id="csv-file-input"
      />
      <label htmlFor="csv-file-input">
        <Button type="button" variant="outline" asChild>
          <span className="flex items-center gap-2">
            <FileUp className="h-4 w-4" />
            Extract Columns from File
          </span>
        </Button>
      </label>
    </div>
  );
};
